module.exports = __webpack_public_path__ + "img/uploadPlus.c8ce712e.svg";